import "@lottiefiles/lottie-player"

export default () => {
    const elements = document.querySelectorAll<HTMLElement>('.wr-lottie');

    if (elements.length <= 0) {
        return
    }
}